import React from 'react';
import PropTypes from 'prop-types';
import { Link, I18n, Status } from 'components';
import classNames from 'classnames/bind';
import { formatDate, formatDateString } from 'utils/formatString';

import styles from '../styles.pcss';
const cx = classNames.bind(styles);

export const ConnectionDateStatus = ({
  namePath, date, requestId, isAllowed, cancelFutureRequest, linkText,
}) => (
  <Status className={[cx('message'), 'attention']} emoji="statusFail">
    {date ? (
      <I18n
        path={namePath}
        vars={{
          date: formatDate(date),
          time: formatDateString(date, 'HH:mm'),
          request_id: requestId,
        }}
      />
    ) : `Услуга ожидает подтверждения, запрос № ${requestId}`}
    <br />
    {isAllowed && <Link onClick={cancelFutureRequest}>{linkText}</Link>}
  </Status>
);

ConnectionDateStatus.propTypes = {
  namePath: PropTypes.string,
  date: PropTypes.string.isRequired,
  requestId: PropTypes.number,
  cancelFutureRequest: PropTypes.func,
  isAllowed: PropTypes.bool,
  linkText: PropTypes.string,
};
